import React from 'react';
import Image from '$/components/NextImage';
import useThemeStore from '$/store/useThemeStore';
import originHeaderLogo from './header-logo.png';

function HeadLogo({
  className,
  headerLogo,
  style = {},
  priority = true,
}: {
  className?: string;
  headerLogo?: string;
  style?: React.CSSProperties;
  priority?: boolean;
}) {
  const theme = useThemeStore((state) => state.theme);
  return (
    <Image
      width={137}
      sizes="137px"
      style={{ width: '137px', filter: theme === 'light' ? 'brightness(0)' : 'none', ...(style || {}) }}
      className={className}
      src={headerLogo || originHeaderLogo}
      alt="avatar"
      priority={priority}
    />
  );
}

export default HeadLogo;
